import { render, staticRenderFns } from "./ButtonUpdate.vue?vue&type=template&id=039642e6&"
import script from "./ButtonUpdate.vue?vue&type=script&lang=js&"
export * from "./ButtonUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports